import { render, staticRenderFns } from "./AlvoradaTipoAnestesia.vue?vue&type=template&id=508d8e50&scoped=true"
import script from "./AlvoradaTipoAnestesia.vue?vue&type=script&lang=ts"
export * from "./AlvoradaTipoAnestesia.vue?vue&type=script&lang=ts"
import style0 from "./AlvoradaTipoAnestesia.vue?vue&type=style&index=0&id=508d8e50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508d8e50",
  null
  
)

export default component.exports